import { render, staticRenderFns } from "./EditCompanyTypePopup.vue?vue&type=template&id=7c78935a"
import script from "./EditCompanyTypePopup.vue?vue&type=script&lang=js"
export * from "./EditCompanyTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports